import React, { useState, useEffect } from 'react';
import './App.css';
import SquadSelection from './components/SquadSelection';
import VoteQuestion from './components/VoteQuestion';
import { Squad } from './lib/supabase';
import { hasVoted, markAsVoted, resetVoteStatus } from './lib/voteControl';

type AppState = 'squad-selection' | 'voting' | 'completed' | 'already-voted';

function App() {
  const [currentState, setCurrentState] = useState<AppState>('squad-selection');
  const [selectedSquad, setSelectedSquad] = useState<Squad | null>(null);

  // 페이지 로드 시 투표 완료 여부 확인
  useEffect(() => {
    if (hasVoted()) {
      setCurrentState('already-voted');
    }
  }, []);

  const handleSquadSelection = (squad: Squad) => {
    setSelectedSquad(squad);
    setCurrentState('voting');
  };

  const handleVoteComplete = () => {
    markAsVoted(); // 투표 완료 상태 저장
    setCurrentState('completed');
  };

  // 관리자용 투표 상태 초기화 (개발/테스트용)
  const handleResetVote = () => {
    resetVoteStatus();
    setCurrentState('squad-selection');
    setSelectedSquad(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>스쿼드 투표 시스템</h1>
        {currentState === 'squad-selection' && (
          <SquadSelection onSquadSelect={handleSquadSelection} />
        )}
        {currentState === 'voting' && selectedSquad && (
          <VoteQuestion 
            voterSquad={selectedSquad} 
            onVoteComplete={handleVoteComplete}
          />
        )}
        {currentState === 'completed' && (
          <div className="completion-message">
            <h2>투표가 완료되었습니다!</h2>
            <p>소중한 의견을 주셔서 감사합니다.</p>
            <p className="vote-info">이 기기에서는 한 번만 투표할 수 있습니다.</p>
          </div>
        )}
        {currentState === 'already-voted' && (
          <div className="already-voted-message">
            <h2>이미 투표하셨습니다!</h2>
          </div>
        )}
      </header>
    </div>
  );
}

export default App;
